export default "__VITE_ASSET__DBoPIeZK__"